<template>
  <div class="container">
       <a-modal class="gufiiguy" title="修改岗位" :visible="editPostVisible"  @cancel="closeAddPost"  width="70%" @ok="editPost">
           <div class="title">
               <span>基本信息</span>

           </div>
           <div class="postTop">
               	<a-form-model :model="addPostForm" :rules="rules" ref="addPostFormRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
						<a-row>
							<a-col :span="8">
								<a-form-model-item label="企业名称"  prop="companyName">
                                    <span>{{ propRowData.companyName }}</span>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
								<a-form-model-item label="项目名称" prop="projectCategory">
                                    <span>{{categoryData2.fullCategory}}</span>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
								<a-form-model-item label="岗位名称"  prop="postName" :rules="{
								  required: true,
								  message: '请选择岗位名称',
								  trigger: 'change',
								}">
                                <a-select
                                allowClear
                                placeholder="请选择岗位"
                                v-model="addPostForm.postName"
                                show-search
                                :filter-option="filterOption"
                                disabled
                                @change="getcheckedItem"
               
                >
                   <!-- v-model="informationList.categoryName"
                  @change="changeCategory" -->
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in postList"
                    :key="index"
                  >
                    {{item.postName}}
                  </a-select-option>
                </a-select>
            </a-form-model-item>
        </a-col>
    </a-row>
     <a-row>
        <a-col :span="8">
            <a-form-model-item label="点位数"  prop="pointNumber" :rules="{
                required: true,
                message: '请输入点位数',
                trigger: 'change',
            }">
            <a-input v-model="addPostForm.pointNumber" allowClear class="a_input_self margin_self" placeholder="请输入"/>
            </a-form-model-item>
        </a-col>
    </a-row>
    </a-form-model>
           </div>
           <div class="title">
               <span>检测项目</span>
           </div>
           <div class="postBottom">
                 <a-table
                    :pagination="false"
                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                    :columns="columns"
                    :data-source="productsList"
                   >

                 </a-table>
            

           </div>

       </a-modal>
      
  </div>
</template>

<script>
import { getItems , getFactorDetail, addQuoteSheetItemsBatch, edititems} from '@/api/Industry'
export default {
    props: ['editPostVisible',
    'propRowData',
    'categoryData2',
    'postList',
    'UUID',
    'multiple',
    'rowInforMation',
    'id',
    'edit'],

    data() {
        return {
            sheetItemsDTOList: {},
            selectedRowKeys: '',
            val: [],
            productsList: [],
            addPostForm: {
                postName: '',
                pointNumber: ''

            },
            columns: [
                 {
                    title: '序号',
                    dataIndex: 'index',
                },
                 {
                    title: '检测项目',
                    dataIndex: 'factorName',
                },
                 {
                    title: '单价',
                    dataIndex: 'price',
                },
                 {
                    title: '检测标准',
                    dataIndex: 'standardInfo',
                },

            ]
            
        }
    },
    created() {
        // this.getData() 

    },
    watch: {
        // rowInforMation(){
            

        // },
        editPostVisible(){
            console.log( this.rowInforMation, ' this.rowInforMation=====================')
             this.addPostForm.postName= this.rowInforMation.postName
           this.addPostForm.pointNumber = this.rowInforMation.val[0].pointNumber
        getFactorDetail({
                postId: this.rowInforMation.val[0].postId
            }).then( res => {
                console.log(res, 'res66666666666666')
                this.productsList = res.data

            } )
           this.selectedRowKeys = this.rowInforMation.val[0].selectedRowKeys
           console.log( this.selectedRowKeys, ' this.selectedRowKeys=====================')
    }

    },
    methods: {
        getData() {
        //   this.addPostForm.postName= this.rowInforMation.postName
        //    this.productsList =  this.rowInforMation.val
           console.log( this.addPostForm.postName, ' this.addPostForm.postName')
        },
        //提交弹窗数据
        editPost() {
            // 表单校验
            this.$refs.addPostFormRef.validate((valid) => {
                if(valid) {
                    if(this.val.length == 0) {
                        this.$message.warning('请变更检测项目！')
                    } else {
              
            this.val.forEach(item => {
                var totalPrice
                totalPrice = item.price*this.addPostForm.pointNumber* this.multiple
                 Object.assign( item,{
                     totalPrice: totalPrice,
                 pointNumber: this.addPostForm.pointNumber, })
            })
            this.sheetItemsDTOList = this.val
            this.edit = 1

            //  for(var i = 0; i < this.val.length; i++ ) {
                //  let list = {}
//  Object.assign( this.sheetItemsDTOList,{
// 
// factorName: this.val[i].factorName,
// price: this.val[i].price,
// standardInfo: this.val[i].standardInfo
//  })
//   this.sheetItemsDTOList.push(list)
//   console.log( this.sheetItemsDTOList, ' this.sheetItemsDTOList=========================')
  

            //  }
            // this.sheetItemsDTOList = this.val
            // this.val.forEach(item => {
            //     Object.assign( this.sheetItemsDTOList,{
            //      pointNumber: this.addPostForm.pointNumber,
            //  })

            // })
             
            //   this.$emit("postDataList", this.sheetItemsDTOList)
            
            addQuoteSheetItemsBatch({
                sheetId: this.UUID,
                postName: this.addPostForm.postName,
                // subId: this.categoryData2.id,
                sheetItemsDTOList: this.sheetItemsDTOList,
                 subName: this.categoryData2.fullCategory
            }).then(res => {
                if (res.code == 200) {
                    Object.assign(this.val[0], {
                      selectedRowKeys:   this.selectedRowKeys
                    })
                                     this.$emit("postDataList", {
                postName:  this.addPostForm.postName,
                selectedRowKeys: this.selectedRowKeys,
                val: this.val ,
                pointNumber: this.addPostForm.pointNumber,
                edit: this.edit = 1
            })
            console.log(this.selectedRowKeys, 'this.selectedRowKeys====================')
              
                this.editPostVisible = false
                this.val = []
                this.selectedRowKeys = ''
                this.addPostForm.pointNumber = ''
                this.addPostForm.postName = ''
                this.productsList = []
                // this.$refs.addPostFormRef.resetFields()
                this.$emit("editVisibleState", this.editPostVisible)
                console.log(res, 'res66666666666666')
                 }
            })
             

                    }
                }
            })

     


        },
        //获取检测项目列表
        getcheckedItem(e) {
            this.selectedRowKeys = ''

            this.postList.forEach(item => {
                if( item.id == e ) {
                    this.addPostForm.postName = item.postName
                }
                
            })
            getFactorDetail({
                postId: e
            }).then( res => {
                console.log(res, 'res66666666666666')
                this.productsList = res.data

            } )
            // getItems({
            //     sheetId: this.UUID,
            //     postName: this.addPostForm.postName
            // }).then(res => {
            //     console.log(res, 'res66666666666666')
            // })


        },
        //下拉搜索
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        closeAddPost() {
            this.editPostVisible = false
            this.$emit("editVisibleState", this.editPostVisible)
            this.val = []
                this.selectedRowKeys = ''
                this.addPostForm.pointNumber = ''
                this.addPostForm.postName = ''
                this.productsList = []
            //清空表单
            // this.$refs.addPostFormRef.resetFields()
        },
         onSelectChange(selectedRowKeys, val) {
            console.log(selectedRowKeys, val)
            this.selectedRowKeys = selectedRowKeys
            console.log( this.selectedRowKeys, ' this.selectedRowKeys000000000000000000000000000')
            this.val = val
            // this.transferVal = val
            // this.dataVal = val
        },
    }

}
</script>

<style>
.container {
    background-color: #f8f8f8;
}
.title {
    font-size: 18px;
    padding: 5px 10px;
    margin: 10px 10px;
}
.postTop,
.postBottom {
    background-color: #fff;
    margin: 5px 10px;
    border-radius: 15px;
}

</style>